
const servicioGeneradorAnios = {

    generarAnios () {
        let currentTime = new Date();
        let year = currentTime.getFullYear();
        let lista=[];
        for(let i=0;i<=10;i++){
            let valor=year-i;
            lista.push({
                 label: valor.toString(), value: valor 
            });
        }
        return lista;
    }

}

export default servicioGeneradorAnios;